import moment from 'moment'
import MD5 from "crypto-js/md5";

export function md5( val ) {
	return MD5(val).toString();
}

export function moneyFormat(value) {
	if (!value && value !== 0) return;

	return value.toLocaleString('ru-RU', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	});
}

export function checkDigitsCount(value, length) {
	let val = "";
	if (value) val = value;

	return val.replace(/\D/g, '').length == length;
}

export function yearsBeforeNow(years) {
	return moment(Date.now()).add(-years, 'years').add(-1, 'days');
}
export function nowAddMonths( value ) {
	return moment(Date.now()).add(value, 'month').format('DD.MM.YYYY');
}

export function formatDateAndTime(date, format) {
    return moment(date).format(format);
}

export function getMoscowTime(format) {
    return moment().utc().add(3, 'hours').format(format);
}

export function makeMoment(date, format) {
    if (/\d{2}\.\d{2}\.\d{4}/.test(date)) {
        return moment(date, format || 'DD.MM.YYYY');
    }

    if (/\d{4}-\d{2}-\d{2}/.test(date)) {
        return moment(date, format || 'YYYY-MM-DD');
    }

    return { isValid: () => false };
}


export function getYears(date) {
	const momentDate = makeMoment(date);

	console.log('momentDate', date);

    if (momentDate.isValid()) {
        return new Date().getFullYear() - momentDate.year();
    }

    return { isValid: () => false };
}